import { ModelInfo } from '../model-info'
import { APPLICANT_RESULT_STATE, APPLY_STATE } from './exam-state-enum'

/**
 * @class UserCertificationResultModel
 * @classdesc 사용자 접수한 시험 결과 뷰
 */
class CompletedExamContent {
  /**
   * @constructor
   * @param {Object} data - 시험 데이터
   * @param {string} data.examName - 시험 이름
   * @param {string} data.examCode - 시험 코드
   * @param {string} data.examNumber - 수험번호
   * @param {Date} data.startAt - 시작 일시
   * @param {Date} data.transactionAt - 결제 일시
   * @param {Date} data.canceledAt - 취소 일시
   * @param {string} data.applyState - 접수 상태 (DRAFT, APPLIED, CANCELED)
   */
  constructor(data) {
    this.examName = data.examName
    this.examCode = data.examCode
    this.examNumber = data.examNumber
    this.startAt = data.startAt
    this.examState = data.examState
    this.examTakenAt = data.examTakenAt
    this.progressState = APPLY_STATE[data.progressState]
    this.score = data.score
    this.totalScore = data.totalScore
    this.result = data.result
  }

  getResultState() {
    return APPLICANT_RESULT_STATE[this.result]
  }

  get isPassed() {
    return this.result === 'PASSED'
  }

  get isAttended() {
    return this.result !== 'NOT_ATTENDED'
  }

  get isFinished() {
    return this.examState === 'FINISHED'
  }
}

export class CompletedExamInfo extends ModelInfo {
  constructor(props) {
    super(props)
    this.content = props.content.map(
      (certificationResult) => new CompletedExamContent(certificationResult)
    )
  }
}
